import { render, staticRenderFns } from "./FormProgramacaoUnidade.vue?vue&type=template&id=d504274c"
import script from "./FormProgramacaoUnidade.vue?vue&type=script&lang=js"
export * from "./FormProgramacaoUnidade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports